import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-finish',
  templateUrl: './confirm-finish.component.html',
  styleUrls: ['./confirm-finish.component.css']
})
export class ConfirmFinishComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmFinishComponent>) { }

  ngOnInit() {
  }

}
